<script>
import Search from '@/components/molecules/Search'
import HeaderUser from '@/components/molecules/HeaderUser'
import DeliveryDetails from '@/components/molecules/DeliveryDetails'
import HeaderCart from '@/components/molecules/HeaderCart'
import { mapGetters } from 'vuex'
import TagsSelectHeader from '@/components/organism/TagsSelectHeader'
import LanguageSelector from '@/components/molecules/LanguageSelector'
import sharedTracking from '@/modules/mixins/sharedTracking'
import ImpersonateBar from '@/components/organism/ImpersonateBar.vue'

export default {
    name: 'PageHeader',
    components: {
        LanguageSelector,
        TagsSelectHeader,
        HeaderCart,
        DeliveryDetails,
        HeaderUser,
        Search,
        ImpersonateBar,
    },

    mixins: [sharedTracking],

    computed: {
        ...mapGetters({
            listView: 'site/listView',
            highlightedListView: 'site/highlightedListView',
            smDevice: 'smDevice',
            lgDevice: 'lgDevice',
        }),
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
        hideOrderDetails() {
            return this.smDevice ? !!this.$route?.meta?.smallDevice?.hideOderDetails : false
        },
        authPage() {
            return this.$route?.meta?.auth
        },
    },
}
</script>

<template lang="pug">
header.page-header(ref="header")
    impersonate-bar
    .header-content
      .header-col(v-if="!hideOrderDetails" :class="{'order-1': smDevice,  'align-items-center': smDevice}")
          delivery-details(v-if="!isSharedTrackingPage" header)
      .header-col(:class="{'order-0': smDevice}" ref="sticky")
          img.logo.cursor-default(v-if="listView" alt="Ordit" v-lazy="'/images/logo.svg'" width="90" height="30")
          router-link.logo.cursor-pointer.z-10(src="/images/logo.svg" tag="img" :to="{name: 'restaurant-list'}" @click.native="$restaurants.reset" v-else)
          .d-inline-flex.ml-auto(v-if="smDevice")
              header-user
              language-selector(v-if="authPage")
      .header-col.justify-content-end(:class="{'order-2': smDevice, 'list-view': listView || highlightedListView}")
          search(:class="{'w-100': smDevice}")
          tags-select-header.ml-5(v-if="smDevice && listView")
          header-cart
          header-user(v-if="lgDevice")
          language-selector(v-if="authPage")
</template>
